import { App } from 'antd';
import Icon from '../../../cpn/Icon';
import { useSKspjdPLDelMutation } from '../../../store/DianShangYeWuApi';
function IncomeNodeDel(props) {
    const {modal,message} = App.useApp(); 
    const [submitDel] = useSKspjdPLDelMutation()  
    return (
        <Icon 
            type='delete' 
            onClick={() => {
                modal.confirm({
                    title: '点击确定将删除审批点',
                    content: '删除后请重新设置审批点！',
                    okText: '确认',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk() {
                        submitDel({
                            ddsr_spjd_user_id:props.ddsr_spjd_user_id+'',
                        }).then((res) => {
                            // console.log(res);
                            if (res.data.Status === 'success') {
                                message.info('删除成功！');
                            }
                            if (res.data.Status === "fail") {
                                message.error('删除失败！'+res.data.Message)
                            }
                        })
                    },
                    onCancel() {
                        // console.log('Cancel');
                    },
                }); 
            }}
        />
    )
}

export default IncomeNodeDel